<div
  class="tipo-de-obra-content titles"
  appDropdownToggle
  #dropdown="dropdownToggle"
  (click)="dropdown.toggle()"
  tabindex="0"
>
  <div class="icon-text">
    <span class="icon-circle">
      <img
        class="img-icon"
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/setor_obra.svg"
        alt=""
        width="22"
        height="22"
      />
    </span>
    <h2>Setor da obra</h2>
  </div>
  <a
    class="btn tipo-de-obra-link"
    data-bs-toggle="collapse"
    role="button"
    aria-expanded="true"
    href="#btn-setor-obra"
    (click)="$event.stopPropagation(); dropdown.toggle()"
    (keydown.enter)="dropdown.toggle()"
    (keydown.space)="dropdown.toggle()"
  >
    <img
      class="img-icon"
      [ngClass]="{ 'girar-icon': dropdown.isOpen }"
      src="{{
        BASE_IMG_URL
      }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
      alt=""
      width="18"
      height="18"
    />
  </a>
</div>
<div
  class="dropdown-tipo-obra"
  *ngIf="dropdown.isOpen && filtroSetorObra.length > 0"
>
  <ul>
    <li *ngFor="let option of filtroSetorObra; let i = index">
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input checkbox tipo-de-obra"
          [id]="option['id']"
          name="checkbox_{{ option['id'] }}"
          [(ngModel)]="option['checked']"
          (change)="onCheckboxChange()"
          (click)="$event.stopPropagation()"
          [class.disabled]="disabled"
          [disabled]="disabled"
        />
        <label class="form-check-label" [for]="option['id']">
          {{ option["description"] }}
        </label>
      </div>
    </li>
  </ul>
</div>
